import { takeLatest, all } from 'redux-saga/effects';
import {
  CREATE_SESSION,
  SMS_REQUEST,
  BRANDS_FETCH,
  TOKEN_VERIFY,
  RESPONSE_SHOW,
  SUBSCRIPTION_REQUEST,
  CHANGE_CARD_REQUEST,
  LOGIN_VENDOR,
  SUBSCRIPTION_V2_REQUEST,
  FETCH_CLIENT,
} from '../constants/actionTypes';
import { handleCreateSession, handleRequestToken, handleVerifyToken } from './session';
import { handleFetchBrands } from './brand';
import { handleRequestSubscription, handleRequestSubscriptionV2 } from './subscription';
import { handleRequestCreditCardChange } from './card';
import { handleShowResponse } from './ui';
import { handleVendorSession } from './vendor';
import { handleFetchClientBySession } from './fetchClient';

export default function* rootSaga() {
  yield all([
    takeLatest(SMS_REQUEST, handleRequestToken),
    takeLatest(TOKEN_VERIFY, handleVerifyToken),
    takeLatest(BRANDS_FETCH, handleFetchBrands),
    takeLatest(CREATE_SESSION, handleCreateSession),
    takeLatest(FETCH_CLIENT, handleFetchClientBySession),
    takeLatest(RESPONSE_SHOW, handleShowResponse),
    takeLatest(SUBSCRIPTION_REQUEST, handleRequestSubscription),
    takeLatest(SUBSCRIPTION_V2_REQUEST, handleRequestSubscriptionV2),
    takeLatest(CHANGE_CARD_REQUEST, handleRequestCreditCardChange),
    takeLatest(LOGIN_VENDOR, handleVendorSession),
  ]);
}
